import { render, staticRenderFns } from "./AddBancarizador.vue?vue&type=template&id=66206b18&"
import script from "./AddBancarizador.vue?vue&type=script&lang=js&"
export * from "./AddBancarizador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports